(function () {
  let attempts = 0;
  const MAX_ATTEMPTS = 20;

  function applyPromoStyles(el) {
    if (!el || el.dataset.promoStyled) return;

    el.dataset.promoStyled = "true";

    // Remove default Shopify class if present
    if (el.classList.contains("metafield-single_line_text_field")) {
      el.removeAttribute("class");
    }

    const isPDP = el.closest(".price-promo-message") !== null;
    const isPLP = el.classList.contains("price-promo-plp");
    const isPS = el.classList.contains("price-promo-ps");
    const isDiscountBlockPLP = el.closest(".card-information__discount") !== null;

    // Shared base styles
    el.style.color = "#ff7cd4";
    el.style.fontWeight = "bold";
    el.style.fontFamily = "'Avenir Book', sans-serif";
    el.style.lineHeight = "1.1";

    // PDP styling
    if (isPDP) {
      el.style.fontSize = "20px";
      el.style.marginTop = "-10px";
      el.style.marginBottom = "2px";
      el.style.opacity = "0";
      el.style.transition = "opacity 0.6s ease, font-size 0.3s ease";
      el.style.display = "inline";

      const wrapper = el.closest(".price-promo-message");
      if (wrapper) {
        wrapper.style.lineHeight = "1";
        wrapper.style.marginTop = "-4px";
        wrapper.style.padding = "0";
      }

      setTimeout(() => {
        el.style.opacity = "1";
      }, 200);
    }

    // PLP styling (e.g. price-promo-plp)
    if (isPLP) {
      el.style.fontSize = "14px";
      el.style.display = "inline";
      el.style.marginLeft = "0px";
    }

    // PDP static PS block
    if (isPS) {
      el.style.fontSize = "16px";
      el.style.display = "block";
      el.style.marginTop = "-10px";
      el.style.marginBottom = "-10px";
    }

    // PLP card-information__discount block (Discount Display)
    if (isDiscountBlockPLP) {
      el.style.fontSize = "14px";
      el.style.display = "block";
      el.style.marginTop = "4px";
      el.style.marginBottom = "2px";
    }

    console.log("[Promo Styled]:", el.textContent);
  }

  function scanAndStyle() {
    const promos = document.querySelectorAll(
      ".price-promo-message .metafield-single_line_text_field, .price-promo-plp, .price-promo-ps, .card-information__discount"
    );

    if (promos.length > 0) {
      promos.forEach(applyPromoStyles);
      console.log(`[Promo Styling Complete] Styled ${promos.length} element(s)`);
      return;
    }

    if (attempts < MAX_ATTEMPTS) {
      attempts++;
      console.log(`[Promo Scan] Attempt ${attempts} – not found yet...`);
      setTimeout(scanAndStyle, 300);
    } else {
      console.warn("[Promo Styling Aborted] Max attempts reached");
    }
  }

  document.addEventListener("DOMContentLoaded", scanAndStyle);
})();
